// extracted by mini-css-extract-plugin
export default {"loader_dot":"EditorLLMDialogLoader__loader_dot--1eH3y","loader":"EditorLLMDialogLoader__loader--3C3aT"};